import styled from 'styled-components';
import { Theme, Popover as MUIPopover, PopoverProps } from '@material-ui/core';
import * as React from 'react';
import type { FC } from 'react';

const getLarge = (props: unknown) => {
  return (props as any)['large'] === "true";
};

const theme = (props: any) => {
  return props.theme as Theme;
}

type StyledPopoverType = React.FC<PopoverProps & { large?: string }>;
export const StyledPopover = styled(MUIPopover)(props => ({
  "& .hierarchy-popover-paper": {
    marginTop: theme(props).spacing(0.5),
    width: getLarge(props) ? '500px' : '225px',
    maxHeight: getLarge(props) ? '360px' : '300px',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
  }
})) as StyledPopoverType & FC<{ large: boolean }>;